/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderMinimalDto
 */
export interface OrderMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof OrderMinimalDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof OrderMinimalDto
     */
    orderTotal?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrderMinimalDto
     */
    orderTotalCurrency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderMinimalDto
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof OrderMinimalDto
     */
    date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof OrderMinimalDto
     */
    externalId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderMinimalDto
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderMinimalDto
     */
    companyId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderMinimalDto
     */
    businessUnitName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderMinimalDto
     */
    businessUnitId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderMinimalDto
     */
    categoryName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderMinimalDto
     */
    categoryId?: string | null;
}

/**
 * Check if a given object implements the OrderMinimalDto interface.
 */
export function instanceOfOrderMinimalDto(value: object): value is OrderMinimalDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function OrderMinimalDtoFromJSON(json: any): OrderMinimalDto {
    return OrderMinimalDtoFromJSONTyped(json, false);
}

export function OrderMinimalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderMinimalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'orderTotal': json['orderTotal'] == null ? undefined : json['orderTotal'],
        'orderTotalCurrency': json['orderTotalCurrency'] == null ? undefined : json['orderTotalCurrency'],
        'description': json['description'] == null ? undefined : json['description'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'businessUnitName': json['businessUnitName'] == null ? undefined : json['businessUnitName'],
        'businessUnitId': json['businessUnitId'] == null ? undefined : json['businessUnitId'],
        'categoryName': json['categoryName'] == null ? undefined : json['categoryName'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
    };
}

export function OrderMinimalDtoToJSON(json: any): OrderMinimalDto {
    return OrderMinimalDtoToJSONTyped(json, false);
}

export function OrderMinimalDtoToJSONTyped(value?: OrderMinimalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'orderTotal': value['orderTotal'],
        'orderTotalCurrency': value['orderTotalCurrency'],
        'description': value['description'],
        'date': value['date'] == null ? value['date'] : value['date'].toISOString(),
        'externalId': value['externalId'],
        'companyName': value['companyName'],
        'companyId': value['companyId'],
        'businessUnitName': value['businessUnitName'],
        'businessUnitId': value['businessUnitId'],
        'categoryName': value['categoryName'],
        'categoryId': value['categoryId'],
    };
}

